const Report = () =>
  import(
    /* webpackChunkName: "financial-tariff-material" */ '@/pages/financial/tariff/material/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "financial-tariff-material" */ '@/pages/financial/tariff/material/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "financial-tariff-material" */ '@/pages/financial/tariff/material/edit.vue'
  )

export default {
  path: 'material',
  meta: {
    label: 'material',
    auth: 'material'
  },
  component: {
    name: 'Material',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialTariffMaterialReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'FinancialCreateMaterialTariff',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'FinancialEditMaterialTariff',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
